import React, { useState, useEffect } from "react";
import Confetti from "react-confetti";
import { Fireworks } from "@fireworks-js/react";
import { motion } from "framer-motion";
import { Fingerprint, Scissors } from "lucide-react";

const InaugurationAnimation = () => {
  const [started, setStarted] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [showCelebration, setShowCelebration] = useState(false);
  const [showRibbon, setShowRibbon] = useState(false);
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isScanning, setIsScanning] = useState(false);
  const [showRibbonConfetti, setShowRibbonConfetti] = useState(false);
  const [isRibbonStretching, setIsRibbonStretching] = useState(false);
  const [isRibbonCut, setIsRibbonCut] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false); // NEW


const line1 = "بِسْمِ ٱللَّٰهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ";
// Instead of text, make it a JSX element with your logo
const line2 = (
  <div className="logo-line">
    <img src="/assets/img/logo/new-logo.png" alt="Logo" />
  </div>
);
const line3 = "New OPD Reception";
const line4 = "Inaugurated By";
const line5 = "Mr. Muhammad Hanif Abbasi";
const line6 = "Federal Minister of Railways";
const line7 = "on 13th August, 2025";
  const [typedLines, setTypedLines] = useState(["", "", "", "", "", "", ""]);

  useEffect(() => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const handleStart = () => {
    if (isScanning) return;
    setIsScanning(true);

    setTimeout(() => {
      setIsScanning(false);
      setIsTransitioning(true);
      setStarted(true);
      setTimeout(() => {
        setShowCelebration(true);
      }, 2000);
    }, 2000);
  };



   const formatTime = (date) =>
    date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });

  const formatDate = (date) =>
    date.toLocaleDateString([], { weekday: "long", year: "numeric", month: "long", day: "numeric" });


   useEffect(() => {
    if (started && showCelebration) {
      const typeLine = async (text, index) => {
        setTypedLines((prev) => {
          const copy = [...prev];
          copy[index] = "";
          return copy;
        });
        for (let i = 0; i < text.length; i++) {
          await new Promise((resolve) => setTimeout(resolve, 80));
          setTypedLines((prev) => {
            const copy = [...prev];
            copy[index] += text.charAt(i);
            return copy;
          });
        }
      };

    const runTyping = async () => {
  await typeLine(line1, 0);

  // Directly show logo without typing
  setTypedLines((prev) => {
    const copy = [...prev];
    copy[1] = line2; // JSX element
    return copy;
  });

  await typeLine(line3, 2);
  await typeLine(line4, 3);
  await typeLine(line5, 4);
  await typeLine(line6, 5);
  await typeLine(line7, 6);
};


      runTyping();
    }
  }, [started, showCelebration]);

  return (
    <>
      <style>{`
        .inauguration-container {
          position: relative;
          width: 100vw;
          height: 100vh;
          overflow: hidden;
          font-family: 'Segoe UI', sans-serif;
          background-image: url('/assets/img/building.jpg');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
        .inauguration-container::before {
          content: '';
          position: absolute;
          inset: 0;
        
          backdrop-filter: blur(3px);
          z-index: 1;
        }
        .video-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

   .bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;

 
}

       /* Waving flag background */
/* Realistic waving Pakistan flag */
.flag-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('./assets/img/pakistan-flag.png');
  background-size: cover;
  background-position: center;
  
  animation: waveFlag 8s ease-in-out infinite;
  filter: brightness(10.05);
}

/* Waving flag effect using distortion */
@keyframes waveFlag {
  0% { transform: perspective(900px) rotateY(0deg) scale(1.05); }
  25% { transform: perspective(900px) rotateY(2deg) scale(1.05); }
  50% { transform: perspective(900px) rotateY(0deg) scale(1.05); }
  75% { transform: perspective(900px) rotateY(-2deg) scale(1.05); }
  100% { transform: perspective(900px) rotateY(0deg) scale(1.05); }
}

/* Soft green overlay stays for mood lighting */
.green-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, rgba(0,128,0,0.18), transparent 70%);
  z-index: -2;
}

/* Floating green particles (unchanged) */
.particle-layer {
  position: absolute;
  inset: 0;
  background: url('/assets/img/green-particles.png');
  background-size: cover;
  opacity: 0.15;
  animation: floatParticles 20s linear infinite;
  z-index: -1;
}
@keyframes floatParticles {
  from { background-position: 0 0; }
  to { background-position: 100% 100%; }
}

/* Gradient fingerprint scan line */
.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #006600, white, #006600);
  animation: scanMove 1.2s linear infinite;
}
@keyframes scanMove {
  0% { transform: translateY(0); }
  100% { transform: translateY(64px); } /* matches fingerprint size */
}

/* Fingerprint glow matches flag theme */
.open-button.scanning .fingerprint-icon {
  animation: fingerprintGlow 1.5s ease-in-out infinite;
}
@keyframes fingerprintGlow {
  0%, 100% {
    filter: drop-shadow(0 0 6px #00ff88);
    transform: scale(1);
  }
  50% {
    filter: drop-shadow(0 0 16px white);
    transform: scale(1.08);
  }
}



        .video-green-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0, 128, 0, 0.45);
          mix-blend-mode: multiply;
          z-index: 1;
          pointer-events: none;
        }
        .button-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 20;
          text-align: center;
          transition: opacity 1s ease;
        }
        .fade-out {
          opacity: 0;
          pointer-events: none;
        }
        .flag-bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: url('/assets/img/flag.png');
          background-size: cover;
          background-position: center;
          opacity: 0.12;
          animation: wave 6s ease-in-out infinite;
          z-index: -1;
        }
        @keyframes wave {
          0%, 100% { transform: translateX(0px) scale(1.05); }
          50% { transform: translateX(-20px) scale(1.05); }
        }
        .logo {
          max-width: 140px;
          margin-bottom: 2rem;
          filter: drop-shadow(0 0 25px rgba(255,255,255,0.4));
        }
        .tagline {
          font-size: 1.6rem;
          font-weight: 600;
          color: #FFD700;
          margin-bottom: 2rem;
          text-shadow: 0 0 10px rgba(255,215,0,0.8);
        }
        .open-button {
          position: relative;
          padding: 1.5rem 3.5rem;
          font-size: 2rem;
          font-weight: bold;
          text-transform: uppercase;
          color: white;
          border: none;
          border-radius: 9999px;
          background: linear-gradient(135deg, #006400, #228B22, #FFD700);
          cursor: pointer;
          overflow: hidden;
          box-shadow: 0 0 60px rgba(255, 255, 255, 0.2);
        }
        .open-button:hover {
          transform: scale(1.08);
          box-shadow: 0 0 90px rgba(255, 255, 255, 0.4);
        }
        .fingerprint-icon {
          stroke: white;
        }
        .open-button.scanning .fingerprint-icon {
          animation: fingerprintGlow 1.5s ease-in-out infinite;
        }
        @keyframes fingerprintGlow {
          0%, 100% {
            filter: drop-shadow(0 0 5px #00ff88);
            transform: scale(1);
          }
          50% {
            filter: drop-shadow(0 0 15px #00ff88);
            transform: scale(1.1);
          }
        }
        .scan-line {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 8px;
          background: rgba(0, 255, 136, 0.7);
          border-radius: 4px;
          animation: scanLineDown 1.5s ease-in-out forwards;
        }
        @keyframes scanLineDown {
          0% { top: 0%; opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { top: 100%; opacity: 0; }
        }
        .video-overlay-text {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          z-index: 25;
        }

     .event-line.first-line {
  margin-bottom: 1.0em; /* bigger space after Bismillah */
  font-size: 3.0rem;
  font-weight: 700;
  color: #006400; /* dark green for white background */
  text-shadow: none; /* remove glow for better readability */
}

.event-line.first-line {
  margin-bottom: 1em;
  font-size: 3rem;
  font-weight: 700;
  color: #006400; /* emerald green */
  text-shadow: 0 0 6px gold, 0 0 12px rgba(255, 215, 0, 0.6);
}

.logo-line {
  text-align: center;
  margin-bottom: 2em; /* Space after logo block */
}

.logo-line img {
  width: 230px;  /* Increased from 240px to 320px */
  height: auto;
  display: inline-block;
}


.event-line {
  margin-bottom: 1em;
  font-size: 3.0rem;
  font-weight: 700;
  background: linear-gradient(90deg, #FF5722, #9C27B0, #2196F3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.guest-line {
  text-transform: uppercase;
  margin-bottom: 1em;
  font-size: 3.5rem;
  font-weight: 800;
  color: rgb(19, 20, 19); /* neon green */
}



.event-dot {
  color: #E91E63;
  font-size: 3.0rem;
  margin-bottom: 1em;
  margin-top:1em;
}

.team-line {
  margin-bottom: 1em;
  font-size: 3rem;
  color: #3F51B5;
  text-shadow: 0 0 5px rgba(63, 81, 181, 0.5);
}



        .clock {
          position: absolute;
          top: 20px;
          right: 30px;
          color: white;
          font-size: 1.1rem;
          font-weight: 500;
          z-index: 50;
        }
        .watermark {
          position: absolute;
          bottom: 10px;
          right: 15px;
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.6);
          z-index: 25;
        }

 .ceremony-header {
  text-align: center;
  padding: 2em 1em;
}

.logo {
  width: 400px; /* bigger logo */
  height: auto;
  margin-bottom: 1em;

}

.inauguration-text {
  text-transform: uppercase;
  font-size: 3.4rem;
  font-weight: bold;
  background: linear-gradient(90deg,rgb(63, 238, 101),rgb(50, 209, 71),rgb(102, 236, 102));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: goldShimmer 3s linear infinite;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.4);
  margin-bottom: 0.6em;
}

.main-title {
  font-size: 3.2rem;
  font-weight: 900;
  color:rgb(116, 240, 240);
  text-shadow: 2px 2px 5px rgba(0,0,0,0.4);
}

.main-subtitle {
  font-size: 2.4rem;
  font-weight: 600;
  color:rgb(31, 236, 236);
  text-shadow: 1px 1px 3px rgba(0,0,0,0.3);
}

@keyframes goldShimmer {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}


      `}</style>


       <div className="inauguration-container">
        {/* <div className="clock">
          {formatDate(currentTime)} <br />
          {formatTime(currentTime)}
        </div> */}

        {started && (
          <video
            src="/assets/img/green-curtain.mp4"
            autoPlay
            muted
            playsInline
            className="bg-video"
          />
        )}

        {showCelebration && (
          <>
            {/* <Confetti width={windowSize.width} height={windowSize.height} /> */}
            <Fireworks
              options={{
                speed: 3,
                particles: 100,
                trace: 3,
                explosion: 5,
                autoresize: true,
                brightness: { min: 50, max: 80 },
              }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 10,
              }}
            />
<motion.div
  className="video-overlay-text"
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ duration: 1.5 }}
>
  <div className="event-line first-line">
    {typeof typedLines[0] === "string" ? typedLines[0] : typedLines[0]}
  </div>
  <div className="logo-line">
    {typedLines[1]}
  </div>
  <div className="event-dot">{typedLines[2]}</div>
  <div className="event-line">{typedLines[3]}</div>
  <div className="guest-line">{typedLines[4]}</div>
  <div className="team-line">{typedLines[5]}</div>
  <div className="team-line">{typedLines[6]}</div>
  <div className="team-line">{typedLines[7]} </div>
</motion.div>


          </>
        )}

 {!started && !isTransitioning && (
  <motion.div
    className={`button-overlay ${fadeOut ? "fade-out" : ""}`}
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 1 }}
  >
    <div className="flag-bg"></div>
    <div className="green-overlay"></div>
    <div className="particle-layer"></div>


<div class="ceremony-header">

  <img src="../assets/img/logo/new-logo.png" alt="Logo" class="logo" />

  <div class="inauguration-text">Inauguration</div>

  <div class="main-title">New OPD</div>
  <div class="main-subtitle">Reception</div>
  
</div>






    {/* Fingerprint button */}
    <motion.button
      className={`open-button ${isScanning ? "scanning" : ""}`}
      onClick={handleStart}
      onTouchStart={handleStart}
      aria-label="Touch fingerprint to open"
      whileTap={{ scale: 1.9 }}
    >
      <div className="fingerprint-container">
        <Fingerprint className="fingerprint-icon" size={54} strokeWidth={1.2} />
        {isScanning && <div className="scan-line" />}
      </div>
    </motion.button>
  </motion.div>
)}





        {/* Watermark */}
        {/* <div className="watermark">
          © 2025 Rawalpindi Institute of Cardiology, Rawalpindi
        </div> */}
      </div>
    </>
  );
};

export default InaugurationAnimation;
